module.exports = __webpack_public_path__ + "static/media/splash-leaves.d8ffb81d.png";